function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { Popover as MuiPopover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import colors from "../../foundations/colors.module.scss";
import { baseMenuPaperStyles } from "../Menu";
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles({
  paper: _objectSpread(_objectSpread({
    background: colors.dark50
  }, baseMenuPaperStyles), {}, {
    margin: 0
  })
});

/** A customized popover based on Material-UI's Popover component. */
export function Popover(props) {
  var _props$anchorOrigin, _additionalProps$anch;
  const {
    classes
  } = props;
  const overrides = useStyles();
  const actualClasses = useMemo(() => {
    return _objectSpread(_objectSpread({}, classes || {}), {}, {
      paper: cn(overrides.paper, classes === null || classes === void 0 ? void 0 : classes.paper)
    });
  }, [classes, overrides]);
  const additionalProps = {};
  if (!(props !== null && props !== void 0 && (_props$anchorOrigin = props.anchorOrigin) !== null && _props$anchorOrigin !== void 0 && _props$anchorOrigin.horizontal)) {
    additionalProps.anchorOrigin = {
      vertical: 'bottom',
      horizontal: 'left'
    };
  }
  if ((additionalProps === null || additionalProps === void 0 || (_additionalProps$anch = additionalProps.anchorOrigin) === null || _additionalProps$anch === void 0 ? void 0 : _additionalProps$anch.horizontal) === 'left') {
    additionalProps.transformOrigin = {
      vertical: -8,
      horizontal: 'left'
    };
  }
  return /*#__PURE__*/_jsx(MuiPopover, _objectSpread(_objectSpread({}, props), {}, {
    classes: actualClasses
  }, additionalProps));
}